import React from "react";
import { getEntityUrl } from "../util";
import { Link } from "gatsby";
import { Box } from "@mui/material";
import { styled } from '@mui/material/styles';
import { Info } from "@mui/icons-material";

const LinkBox = styled(Box)(({ theme }) => ({
    position: 'absolute',
    bottom: 0,
    right: 0,

    padding: '.5em',
    fontSize: 'small',
    textAlign: 'right',

    '& a': {
        color: '#000',
        textDecoration: 'none',
    }
}));

/**
 * @typedef {Object} AssociatedEntity
 * @property {import("../repository/EntityRepository").Entity} entity
 * @property {string?} text
 * @property {string?} title
 */

/**
 * A component that renders a link to an associated entity.
 *
 * @param {{ associatedEntity: AssociatedEntity; defaultLocale: string }} props
 */
export const ListItemAssociatedEntity = ({ associatedEntity, defaultLocale }) => {
    const entityUrl = associatedEntity?.entity ? getEntityUrl({ entity: associatedEntity.entity, defaultLocale }) : undefined;

    return (
        associatedEntity?.entity ?
        <LinkBox className="associatedLink">
            <Link to={entityUrl} {...(associatedEntity.title && { title: associatedEntity.title })} >
                {associatedEntity.text && <span style={ {'verticalAlign': 'top'} } >{associatedEntity.text}</span>}
                <Info fontSize="small" size="small" sx={{ marginLeft: '.2em' }} />
            </Link>
        </LinkBox>
        : <></>
    )
}
